(function() {
    'use strict';

    var module = angular.module('doclr.printer', []);

    module.factory('printer', function($q) {
        const printerDefaults = {
            width: 105,
            height: 210,
            marginLeftRight: 10,
            marginTopBottom: 20,
            fontSize: 11,
            titleSize: 13,
            bodyWidth: 85,
            lineHeight: 8,
            spacer: 8
        };

        /*only load jspdf if needed*/
        var JsPDFLoader = {
            load : function() {
                var deferred = $q.defer();
                /*global require*/
                require(['jspdf'], function(JsPDF) {
                    deferred.resolve(JsPDF);
                });
                return deferred.promise;
            }
        };

        var printAfspraak = function(afspraakDetail, praktijkContext, location, options) {
            location = location ? location : praktijkContext;
            var printerOptions = angular.extend({}, printerDefaults, options);
            JsPDFLoader.load().then(function(JsPDF) {
                var yPos = printerOptions.marginTopBottom;
                var doc = new JsPDF('p', 'mm', [printerOptions.width, printerOptions.height]);
                doc.setFont('helvetica');
                doc.setFontSize(printerOptions.fontSize);
                // title
                doc.setFontType('normal');
                doc.setFontSize(printerOptions.titleSize);
                doc.text(printerOptions.marginLeftRight, yPos, doclrVertaal.instant('print.appointment.confirmation.label'));

                // moment
                doc.setFontSize(printerOptions.fontSize);
                var afspraakMoment = moment(afspraakDetail.dag + ' ' + afspraakDetail.van, 'YYYY-MM-DD H:mm');
                doc.setFontType('bold');
                doc.text(printerOptions.marginLeftRight, yPos += printerOptions.spacer + printerOptions.lineHeight, doclrVertaal.instant('print.appointment.appointment.label'));
                doc.setFontType('normal');
                doc.text(printerOptions.marginLeftRight, yPos += printerOptions.lineHeight, afspraakMoment.format('dddd D MMMM YYYY [om] H[u]mm'));

                // agenda
                doc.setFontSize(printerOptions.fontSize);
                doc.setFontType('bold');
                doc.text(printerOptions.marginLeftRight, yPos += printerOptions.lineHeight, doclrVertaal.instant('print.appointment.with.label'));
                doc.setFontType('normal');
                doc.text(printerOptions.marginLeftRight, yPos += printerOptions.lineHeight, afspraakDetail.agendaNaam || '');

                // naam
                if(afspraakDetail.naam){
                    doc.setFontSize(printerOptions.fontSize);
                    doc.setFontType('bold');
                    doc.text(printerOptions.marginLeftRight, yPos += printerOptions.lineHeight, doclrVertaal.instant('print.appointment.nameOf.label'));
                    doc.setFontType('normal');
                    doc.text(printerOptions.marginLeftRight, yPos += printerOptions.lineHeight, [afspraakDetail.naam, afspraakDetail.voornaam].join(' '));
                }

                // praktijkgegevens
                yPos = 170;
                doc.setFontSize(printerOptions.fontSize);
                doc.setFontType('bold');
                doc.text(printerOptions.marginLeftRight, yPos, praktijkContext.naam);
                doc.setFontType('normal');
                doc.text(printerOptions.marginLeftRight, yPos += printerOptions.lineHeight, [location.straat, location.nummer, location.bus].join(' '));
                doc.text(printerOptions.marginLeftRight, yPos += printerOptions.lineHeight, [location.postcode, location.gemeente].join(' '));
                doc.text(printerOptions.marginLeftRight, yPos += printerOptions.lineHeight, location.telefoon || '');

                let postfix;

                if(afspraakDetail.id){
                    postfix =  afspraakDetail.id.split('/').pop();
                }else{
                    postfix = afspraakMoment.format('YYYY_MM_DD_HH_mm');
                }
                doc.save('afspraak-' + postfix + '.pdf');
            });
        };

        return {
            printAfspraak
        };
    });


})();


